<template>
  <section class="home-trust-ribbon relative overflow-hidden py-8 sm:py-10" :aria-labelledby="headingId">
    <div class="home-trust-ribbon__glow home-trust-ribbon__glow--left" aria-hidden="true"></div>
    <div class="home-trust-ribbon__glow home-trust-ribbon__glow--right" aria-hidden="true"></div>

    <div class="home-trust-ribbon__inner relative mx-auto max-w-screen-xl px-6 lg:px-8 2xl:px-0">
      <div class="home-trust-ribbon__panel grid gap-8 rounded-[1.75rem] px-5 py-6 sm:px-8 sm:py-8 lg:grid-cols-[minmax(0,1.12fr)_minmax(460px,0.88fr)] lg:items-center lg:gap-12">
        <div>
          <p class="mb-3 inline-flex items-center gap-2 text-[11px] font-extrabold uppercase tracking-[0.2em] text-amber-200">
            <span class="h-1.5 w-1.5 rounded-full bg-amber-300 shadow-[0_0_14px_rgba(252,211,77,0.95)]"></span>
            {{ copy.eyebrow }}
          </p>
          <h2 :id="headingId" class="mb-3 max-w-2xl text-2xl font-semibold leading-tight tracking-tight text-white sm:text-3xl">
            {{ copy.title }}
          </h2>
          <ul class="flex flex-wrap gap-x-4 gap-y-2 text-xs font-semibold text-slate-200 sm:text-sm" :aria-label="copy.highlightsLabel">
            <li v-for="item in copy.highlights" :key="item" class="inline-flex items-center gap-2">
              <span class="h-1.5 w-1.5 rounded-full bg-amber-300"></span>{{ item }}
            </li>
          </ul>

          <div class="mt-5 flex flex-wrap gap-3">
            <a
              :href="getPath('/page/umre-hizmet-standartlari')"
              class="inline-flex items-center gap-2 rounded-xl bg-white px-4 py-2.5 text-sm font-bold text-slate-900 shadow-[0_14px_32px_-18px_rgba(0,0,0,0.75)] transition hover:-translate-y-0.5 hover:bg-amber-50"
              @click.prevent="goPath('/page/umre-hizmet-standartlari')"
            >
              {{ copy.standardsCta }}
              <font-awesome-icon icon="fa-solid fa-arrow-right" class="h-3.5 w-3.5" />
            </a>
            <a
              href="tel:+908502414141"
              class="inline-flex items-center gap-2 rounded-xl border border-white/25 bg-white/10 px-4 py-2.5 text-sm font-bold text-white backdrop-blur-sm transition hover:border-amber-300/70 hover:bg-white/15"
            >
              <font-awesome-icon icon="fa-solid fa-phone" class="h-3.5 w-3.5 text-amber-200" />
              {{ copy.phoneCta }}
            </a>
          </div>
        </div>

        <ul class="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-2" :aria-label="copy.statsLabel">
          <li v-for="stat in stats" :key="stat.label" class="home-trust-ribbon__stat flex items-center gap-3 rounded-2xl px-4 py-3.5">
            <span class="home-trust-ribbon__stat-icon inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-xl">
              <font-awesome-icon :icon="stat.icon" class="h-4 w-4 text-amber-200" />
            </span>
            <span class="min-w-0">
              <strong class="block text-xl font-extrabold tracking-tight text-white sm:text-2xl">{{ stat.value }}</strong>
              <span class="mt-0.5 block text-[11px] leading-4 text-slate-300">{{ stat.label }}</span>
            </span>
          </li>
        </ul>
      </div>
    </div>
  </section>
</template>

<script setup>
const { locale } = useI18n()
const { getPath, goPath } = useCommon()
const headingId = 'home-trust-heading'

const copy = computed(() => locale.value === 'en'
  ? {
      eyebrow: 'A documented service standard',
      title: 'Trust is visible in every detail of your Umrah journey.',
      highlights: ['Named hotels', 'Clear itinerary', 'Dedicated guidance'],
      highlightsLabel: 'Programme service highlights',
      standardsCta: 'See service standards',
      phoneCta: 'Speak to an advisor',
      statsLabel: 'Inanc Tour trust indicators',
    }
  : {
      eyebrow: 'Belgelendirilmiş hizmet standardı',
      title: 'Yüksek Standartlarda Hizmet',
      highlights: ['En iyi oteller', 'Net yolculuk planı', 'Kesintisiz rehberlik'],
      highlightsLabel: 'Program hizmet başlıkları',
      standardsCta: 'Hizmet standartlarını incele',
      phoneCta: 'Uzmanımıza danışın',
      statsLabel: 'İnanç Turizm güven göstergeleri',
    })

const stats = computed(() => locale.value === 'en'
  ? [
      { value: '21 years', label: 'Experience', icon: 'fa-solid fa-medal' },
      { value: '30,000+', label: 'Pilgrims served', icon: 'fa-solid fa-people-group' },
      { value: '3,500', label: 'Annual pilgrims', icon: 'fa-solid fa-calendar-check' },
      { value: 'TÜRSAB 7677', label: 'Licensed agency', icon: 'fa-solid fa-shield-halved' },
    ]
  : [
      { value: '21 yıl', label: 'Deneyim', icon: 'fa-solid fa-medal' },
      { value: '30.000+', label: 'Umre yolcusu', icon: 'fa-solid fa-people-group' },
      { value: '3.500', label: 'Yıllık yolcu', icon: 'fa-solid fa-calendar-check' },
      { value: 'TÜRSAB 7677', label: 'Belgeli acenta', icon: 'fa-solid fa-shield-halved' },
    ])
</script>

<style scoped>
.home-trust-ribbon { background: linear-gradient(180deg, rgba(248, 250, 252, 0.98), #fff); }
.home-trust-ribbon__panel { position: relative; overflow: hidden; border: 1px solid rgba(230, 194, 115, 0.38); background: radial-gradient(circle at 82% 8%, rgba(195, 143, 36, 0.23), transparent 31%), radial-gradient(circle at 10% 90%, rgba(20, 116, 108, 0.18), transparent 38%), linear-gradient(122deg, #11243b 0%, #172f4b 52%, #0d1c2d 100%); box-shadow: 0 28px 60px -38px rgba(15, 31, 49, 0.82); }
.home-trust-ribbon__panel::before { position: absolute; inset: 0; content: ''; opacity: 0.35; background-image: radial-gradient(rgba(255, 255, 255, 0.28) 0.7px, transparent 0.7px); background-size: 22px 22px; mask-image: linear-gradient(90deg, transparent, #000 22%, #000 78%, transparent); pointer-events: none; }
.home-trust-ribbon__stat { position: relative; min-height: 88px; border: 1px solid rgba(255, 255, 255, 0.13); background: rgba(255, 255, 255, 0.075); box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06); backdrop-filter: blur(10px); }
.home-trust-ribbon__stat-icon { border: 1px solid rgba(230, 194, 115, 0.22); background: rgba(195, 143, 36, 0.1); }
.home-trust-ribbon__glow { position: absolute; width: 22rem; height: 22rem; border-radius: 9999px; filter: blur(70px); opacity: 0.15; pointer-events: none; }
.home-trust-ribbon__glow--left { top: -16rem; left: -12rem; background: #c58f24; }
.home-trust-ribbon__glow--right { right: -12rem; bottom: -17rem; background: #0f766e; }

@media (min-width: 768px) and (max-width: 1439px) {
  .home-trust-ribbon__inner { padding-inline: clamp(1.5rem, 2.5vw, 2rem); }
}
</style>
